import { c as _c } from "react/compiler-runtime";
import { ReactNode } from 'react';
import { Card, CardBody, Copyright } from '@personly/libs-widgets';
import type { Scheme } from '@personly/libs-types';
import BrandJumbotron from '@/components/brand-jumbotron';
interface Props {
  children: ReactNode;
  name: string;
  schemes: Array<Scheme>;
}
const ErrorView = t0 => {
  const $ = _c(11);
  const {
    children,
    name,
    schemes
  } = t0;
  let t1;
  if ($[0] !== name || $[1] !== schemes) {
    t1 = <div><BrandJumbotron alt={name} schemes={schemes} /></div>;
    $[0] = name;
    $[1] = schemes;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== children) {
    t2 = <div>{children}</div>;
    $[3] = children;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== name) {
    t3 = <div className="flex justify-center"><Copyright name={name} /></div>;
    $[5] = name;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t1 || $[8] !== t2 || $[9] !== t3) {
    t4 = <div className="w-full flex sm:container justify-center px-3 mx-auto sm:px-0"><div className="w-full sm:w-3/5 lg:w-2/5"><Card shadow={true}><CardBody><div className="flex flex-col gap-4">{t1}{t2}{t3}</div></CardBody></Card></div></div>;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
};
export default ErrorView;